import { render, staticRenderFns } from "./DirectoryTNC.vue?vue&type=template&id=847ccd82&scoped=true&"
import script from "./DirectoryTNC.vue?vue&type=script&lang=js&"
export * from "./DirectoryTNC.vue?vue&type=script&lang=js&"
import style0 from "./DirectoryTNC.vue?vue&type=style&index=0&id=847ccd82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847ccd82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('847ccd82')) {
      api.createRecord('847ccd82', component.options)
    } else {
      api.reload('847ccd82', component.options)
    }
    module.hot.accept("./DirectoryTNC.vue?vue&type=template&id=847ccd82&scoped=true&", function () {
      api.rerender('847ccd82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/engineers/regionConfig/DirectoryTNC.vue"
export default component.exports